import { treeAspect, wikiTab, jobTab, customizeJobRouting, isRootDomainConfig } from 'uix/views/utils';
const harvesterEnabled = (datatypes, allDomains)=>({ datatype, dconfig, iconfig })=>datatypes.includes(datatype) && iconfig.oaiharvester.on && (allDomains || dconfig.oaiharvester.on);
const _import = {
    ...treeAspect,
    acl: 'g:admin,g:oaiManager',
    tabGroup: 'import',
    tabs: {
        harvester: {
            tabGroupDefault: true,
            enabled: harvesterEnabled([
                10,
                1
            ], true),
            parts: [
                'OaiHarvester'
            ],
            minorTabGroup: 'harvester'
        },
        oairecs: {
            enabled: harvesterEnabled([
                10
            ], true),
            parts: [
                'OaiHarvester'
            ],
            minorTabGroup: 'harvester'
        },
        oai: {
            enabled: harvesterEnabled([
                10
            ]),
            parts: [
                'OaiHarvester'
            ],
            minorTabGroup: 'harvester'
        },
        oaijob: {
            enabled: harvesterEnabled([
                10
            ]),
            label: 'Job',
            parts: [
                'OaiHarvester'
            ],
            minorTabGroup: 'harvester',
            customizeRouting: customizeJobRouting
        },
        directory: {
            default: true,
            tabGroupDefault: true,
            acl: 'g:admin',
            datatype: [
                10
            ],
            parts: [
                'ImportDirectories'
            ]
        },
        upload: {
            acl: 'g:admin',
            datatype: [
                10
            ],
            parts: [
                'ImportUpload'
            ]
        },
        //~ package: {datatype: [10], parts: ['ImportPackage']},
        packages: {
            acl: 'g:admin',
            datatype: [
                1,
                10
            ],
            parts: [
                'ImportPackages'
            ]
        },
        config: {
            datatype: [
                10
            ],
            parts: [
                'ImportConfig'
            ],
            acl: 'g:admin'
        },
        job: jobTab({
            names: 'import,upload',
            acl: 'g:admin'
        }),
        form: {
            datatype: [
                10
            ],
            acl: 'g:admin',
            cfg: ({ dconfig })=>dconfig.modsforms.on,
            parts: [
                {
                    type: 'ModsForm',
                    filters: [
                        {
                            type: 'ModsWebEditor',
                            action: 'create',
                            lazy: 'true'
                        },
                        'showAvailableFormtypes'
                    ]
                }
            ]
        }
    }
};
export { _import as import };
